import { atom } from "jotai";

export const contratosAtom = atom([]);
export const contratoSeleccionadoAtom = atom(undefined);
export const urlPdfContratoAtom = atom(undefined);
export const visibleModalVisorPdfAtom = atom(false);
export const visibleModalRechazarContratoAtom = atom(false);
export const visibleModalModificarContratoAtom = atom(false);
